import {Loader} from 'rsuite';

const SimpleLoader = (props) =>
    <Loader backdrop={true} content={props.message} vertical speed='slow' size='lg' style={{zIndex: 9100}}/>;

export default SimpleLoader;
